<template>
  <div class="ajuste">
    <barSlider></barSlider>
  </div>
  <!-- Componente Destacados (cargado inmediatamente) -->
  <div class="spacer" id="spacer-destacados"></div>
  <div v-if="loadingComponents.destacados" class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <destacados v-if="loadedComponents.destacados"></destacados>

  <!-- Componentes cargados al hacer scroll -->
  <template v-for="component in componentOrder" :key="component">
    <div :class="'spacer'" :id="'spacer-' + component"></div>
    <div v-if="loadingComponents[component]" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <component :is="component" v-if="loadedComponents[component]"></component>
  </template>
</template>

<script>
import barSlider from '../Home/itemSlider.vue';
import destacados from '../components/navegation/ComponentsRecomend/CompoentsHome/SeccionProdsDestacar.vue';
import boletinprodnuevos from '../Home/boletinprodnuevos.vue';
import ComponentWithTemplate from '../Home/promocionesdestacadas.vue';
import SliderPromoActivas from '../Home/SliderPromoActivas.vue';
import barItem from '../Home/itembar.vue';
import itembestbuyprods from '../Home/itemsbestbuyprods.vue';
import marcas from '../Home/marcaslineas.vue';

import throttle from 'lodash/throttle'
export default {
  components: {
    barSlider,
    destacados,
    boletinprodnuevos,
    ComponentWithTemplate,
    SliderPromoActivas,
    barItem,
    itembestbuyprods,
    marcas,
  },
  data() {
    return {
      empresa: '',
      componentOrder: [
        'barItem',
        'itembestbuyprods',
        'marcas',
        'SliderPromoActivas',
        'PublicacionesBlog',
        'boletinprodnuevos',
        'ComponentWithTemplate',
      ],
      loadedComponents: {
        destacados: false,
        boletinprodnuevos: false,
        ComponentWithTemplate: false,
        SliderPromoActivas: false,
        barItem: false,
        PublicacionesBlog: false,
        itembestbuyprods: false,
        marcas: false,
      },
      loadingComponents: {
        destacados: false,
        boletinprodnuevos: false,
        ComponentWithTemplate: false,
        SliderPromoActivas: false,
        barItem: false,
        PublicacionesBlog: false,
        itembestbuyprods: false,
        marcas: false,
      },
      scrollThresholds: {
        barItem: 50,
        itembestbuyprods: 100,
        marcas: 150,
        SliderPromoActivas: 200,
        PublicacionesBlog: 250,
        boletinprodnuevos: 300,
        ComponentWithTemplate: 350,
        
      }
      /*
       scrollThresholds: {
        boletinprodnuevos: 50,
        ComponentWithTemplate: 100,
        SliderPromoActivas: 150,
        barItem: 200,
        PublicacionesBlog: 250,
        itembestbuyprods: 300,
        marcas: 350,
      }
      */
    };
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY;
      let previousComponentLoaded = true;

      this.componentOrder.forEach((component) => {
        if (!this.loadedComponents[component] && scrollY >= this.scrollThresholds[component]) {
          if (!previousComponentLoaded) return;

          this.loadingComponents[component] = true;
          setTimeout(() => {
            this.loadedComponents[component] = true;
            this.loadingComponents[component] = false;
          }, 2000);

          previousComponentLoaded = false;
        } else if (this.loadedComponents[component]) {
          previousComponentLoaded = true;
        }
      });
    }
  },
  mounted() {
    //this.sucursalescontacto();
    this.loadedComponents.destacados = true;

    this.throttledScroll = throttle(this.handleScroll, 200);
    window.addEventListener('scroll', this.throttledScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.throttledScroll);
  }
};
</script>
<style scoped>
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  /* Ajusta la altura según sea necesario */
}

.spinner-dots {
  display: flex;
  gap: 30px;
  color: #06283c;
  /* Espacio entre los puntos */
}

.spinner-dots span {
  font-size: 50px;
  /* Tamaño de los puntos */
  animation: pulse 0.6s infinite alternate;
  /* Animación de los puntos */
}

@keyframes pulse {
  0% {
    opacity: 0.3;
    transform: scale(0.8);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
